<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width"
						:event="item.event">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style="width: 100%; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<TechnicalOfficesTable :tableData="tableData" :total="total" :typeOptions="typeOptions" :productLineOptions="productLineOptions" @Export="customerExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</TechnicalOfficesTable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import TechnicalOfficesTable from "./components/TechnicalOfficesTable.vue";

	import {
		GetTechnicalOfficesList,
		ExportTechnicalOffices,
		GetHelperTOType
	} from "@/api/newsapi";
	import {
		InventoryClassList
	} from "@/api/home";
	import utils from "../../../common/utils";

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			TechnicalOfficesTable,
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				typeOptions: [],
				productLineOptions: [],
				form: {},
				formdata: [{
						inputdata: "",
						title: "名称",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "医院",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "220px",
						lablewith: "117px",
					},
					{
						inputdata: "",
						title: "类型",
						fontSize: "14px",
						color: "#333333",
						placeholder: "全部",
						types: "",
						inputtype: "select",
						width: "220px",
						lablewith: "117px",
						options: [],
					},
					{
						inputdata: "",
						title: "创建时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "date",
						inputtype: "dateSection",
						width: "220px",
						lablewith: "117px",
						widthLeft: 180,
						widthRight: 180,
					}
				],
			};
		},
		mounted() {
			this.getProductLineList();
			this.getTOTypeList();
			this.customerList();
		},
		methods: {
			// 获取产品线
			async getProductLineList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.productLineOptions = data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}));
				}
			},
			// 获取类型下拉
			async getTOTypeList() {
				let {
					code,
					data
				} = await GetHelperTOType({})
				if (code == 0) {
					this.typeOptions = data.map(item => ({
						key: item.Value,
						value: item.Text
					}))
					this.formdata[2].options = this.typeOptions
				}
			},
			// 列表
			async customerList() {
				let {
					data,
					code
				} = await GetTechnicalOfficesList({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
					if (index === 3) {
						item.startTime = "";
						item.endTime = "";
					}
				});
				this.form = {};
				this.customerList();
			},
			select() {
				this.pageindex = 1;
				this.form.TOName = this.$refs.seselect[0].modelvalue;
				this.form.HospitalName = this.$refs.seselect[1].modelvalue;
				this.form.TOType = this.$refs.seselect[2].modelvalue;
				this.form.CreateTime1 = this.$refs.seselect[3].endTime;
				this.form.CreateTime2 = this.$refs.seselect[3].startTime;
				this.customerList();
			},
			// 导出
			async customerExport() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportTechnicalOffices({
					...this.form,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "医院科室档案", "xlsx");
				} else {
					this.$message.warning("导出失败");
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 100%;
		height: 125px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>